import { render, staticRenderFns } from "./SelectProperty.vue?vue&type=template&id=5b44e8fe&"
import script from "./SelectProperty.vue?vue&type=script&lang=js&"
export * from "./SelectProperty.vue?vue&type=script&lang=js&"
import style0 from "./SelectProperty.vue?vue&type=style&index=0&id=5b44e8fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports